import { useCallback, useEffect, useMemo, useRef, useState } from "react";

import LogUtils from "../../../../../libs/LogUtils";
import SnackbarUtils from "../../../../../libs/SnackbarUtils";
import historyUtils from "../../../../../libs/history.utils";
import RouteName from "../../../../../routes/Route.name";
import {
  serviceCreateGroup,
  serviceGetGroupDetail,
  serviceUpdateGroup,
} from "../../../../../services/Chat.service";
import { useLocation } from "react-router-dom";

const initialForm = {
  name: "",
  display_type: "IMAGE",
  description: "",
  // employee_ids: ["67bef9a8dd8a2745c5034ac7"],
  should_admin_only_send: false,
};

const GroupTypeLabel = {
  GRADES: "GRADE",
  DESIGNATIONS: "DESIGNATION",
  ZONES: "ZONE",
  STATES: "STATE",
  HQS: "HQ",
  LOCATIONS: "LOCATION",
};

const useGroupCreateHook = ({
  groupId,
  handleSidePanelToggle,
  handleClosepopOver,
  fetchChatInfo,
  setChatUser,
  setTabIndex,
}) => {
  const [isLoading, setIsLoading] = useState(false);
  const [errorData, setErrorData] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [editEmployee, setEditEmployee] = useState();
  const [form, setForm] = useState({ ...initialForm });
  const location = useLocation();
  useEffect(() => {
    if (groupId) {
      const req = serviceGetGroupDetail({ id: groupId });
      req.then((res) => {
        if (!res?.error) {
          const data = res?.data;
          setForm({
            name: data?.name,
            display_type: data?.display_type,
            description: data?.description,
            should_admin_only_send: data?.is_close_group || false,
          });

          setEditEmployee({
            employees: data?.employees || [],
            filtered_by:
              Object.keys(GroupTypeLabel)?.find(
                (key) => GroupTypeLabel[key] === data?.group_type
              ) || "",
            type: data?.groupRef || [],
          });
        }
      });
    }
  }, [groupId]);

  const checkFormValidation = useCallback(() => {
    const errors = {};
    let required = ["name", "display_type", "description"];

    required.forEach((val) => {
      if (
        !form?.[val]?.trim() ||
        (Array.isArray(form?.[val]) && form?.[val].length === 0)
      ) {
        errors[val] = true;
      }
    });
    Object.keys(errors).forEach((key) => {
      if (!errors[key]) {
        delete errors[key];
      }
    });
    return errors;
  }, [form, errorData]);
  const submitToServer = useCallback(
    (employees, formType, isShowFilter) => {
      if (!isLoading) {
        setIsSubmitting(true);
        setIsLoading(true);
        const fd = { ...form };
        fd.employee_ids = employees?.map((val) => val?.id) || [];
        fd.group_type = isShowFilter && formType?.filtered_by
          ? GroupTypeLabel[formType?.filtered_by]
          : "NONE";
        fd.group_ref_ids = formType?.type?.map((val) => val?.id) || [];
        let req;
        if (groupId) {
          fd.id = groupId;
          req = serviceUpdateGroup;
        } else {
          req = serviceCreateGroup;
        }
        req(fd).then((res) => {
          if (!res.error) {
            SnackbarUtils.success(
              `Group ${groupId ? "Updated" : "Created"} Successfully`
            );
            handleClosepopOver && handleClosepopOver();
            handleSidePanelToggle();
            fetchChatInfo && fetchChatInfo();
            setChatUser && setChatUser(null);
            historyUtils.replace(
              location?.pathname === "/messaging"
                ? RouteName.MESSAGING
                : RouteName.AUDIT_GROUP
            );
            setTabIndex && setTabIndex(1);
          } else {
            SnackbarUtils.error(res?.message);
          }
          setIsSubmitting(false);
          setIsLoading(false);
        });
      }
    },
    [
      form,
      isSubmitting,
      setIsSubmitting,
      isLoading,
      setIsLoading,
      handleSidePanelToggle,
      fetchChatInfo,
    ]
  );

  const handleSubmit = useCallback(
    (employees, formType, isShowFilter) => {
      if (isShowFilter && !groupId && !formType?.filtered_by) {
        SnackbarUtils.error(" Please select the Filter member by");
        return;
      }
      if (isShowFilter && !groupId && !formType?.type?.length) {
        SnackbarUtils.error(
          `Please select the  ${GroupTypeLabel[formType?.filtered_by]} type`
        );
        return;
      }
      if (!employees?.length) {
        SnackbarUtils.error("Please add at least one employee");
        return true;
      }
      const errors = checkFormValidation();
      if (Object.keys(errors).length > 0) {
        setErrorData(errors);
        return true;
      }
      submitToServer(employees, formType, isShowFilter);
    },
    [
      checkFormValidation,
      setErrorData,
      form,
      isLoading,
      setIsLoading,
      fetchChatInfo,
    ]
  );

  const removeError = useCallback(
    (title) => {
      const temp = JSON.parse(JSON.stringify(errorData));
      temp[title] = false;
      setErrorData(temp);
    },
    [setErrorData, errorData]
  );

  const changeTextData = useCallback(
    (text, fieldName) => {
      LogUtils.log(text, fieldName);
      let shouldRemoveError = true;
      const t = { ...form };

      t[fieldName] = text;
      setForm(t);
      shouldRemoveError && removeError(fieldName);
    },
    [removeError, form, setForm]
  );
  const onBlurHandler = useCallback(
    (type) => {
      if (form?.[type]) {
        changeTextData(form?.[type].trim(), type);
      }
    },
    [changeTextData]
  );

  const handleDelete = useCallback(() => {}, []);

  const handleReset = useCallback(() => {
    setForm({ ...initialForm });
  }, [form]);

  return {
    form,
    changeTextData,
    onBlurHandler,
    removeError,
    handleSubmit,
    isLoading,
    isSubmitting,
    errorData,
    handleDelete,
    handleReset,
    editEmployee,
  };
};

export default useGroupCreateHook;
